import RequestBase from './RequestBase';

export default class PostcodeSearchRequest extends RequestBase {
    constructor(postcode) {
        super();
        this._url = '/Addresses';
        this.method = 'GET';
        this.qs = {
            'postcode': postcode
        };
    }
}



// WEBPACK FOOTER //
// ./src/Resources/Addresses.js